var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React, { useEffect, useState } from "react";
import { FormBuilderForm } from "../public/js/react/feature/form-builder/components/form/form-builder.form";
import { LazyLoader } from "../public/js/caching-lazy-loader";
export const FormBuilder = ({ config, onAfterLoad, onAfterSubmit, onBeforeSubmit }) => {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const analyticsLoader = new LazyLoader(
    `${window._env_.BASE_URL}/dist/tintAnalyticsClient-bundle.js`,
    "tintAnalyticsClient",
    {
      traits_namespace: "form_builder",
      defaultDatabase: "tint-analytics",
      defaultTable: "form_embed_events"
    }
  );
  const analyticsClient = analyticsLoader.getProxy();
  useEffect(() => {
    fetch(
      `${window._env_.API_URL}/v2/teams/${config.teamId}/forms/${config.formId}?include=media&fields[form]=groups,layout,locales,tracking_enabled`,
      {
        headers: { "Content-Type": "application/json" }
      }
    ).then((response) => {
      if (!response.ok) {
        if (response.status === 404) {
          setError(404);
        } else {
          setError(404);
        }
        return;
      }
      return response.json();
    }).then((data2) => {
      var _a, _b, _c;
      if (((_c = Object.values(((_b = (_a = data2 == null ? void 0 : data2.data) == null ? void 0 : _a.attributes) == null ? void 0 : _b.groups) || {})) == null ? void 0 : _c.length) === 0) {
        setError(404);
        return;
      }
      setData(__spreadProps(__spreadValues({}, data2.data.attributes), {
        included: data2 == null ? void 0 : data2.included,
        apiUrl: config.apiUrl,
        formId: config.formId,
        teamId: config.teamId,
        formValues: config.formValues,
        noTrack: config.noTrack,
        accessToken: config.accessToken,
        metadata: config.metadata
      }));
      if (onAfterLoad) config.hostElement.addEventListener("afterLoad", onAfterLoad);
      if (onAfterSubmit)
        config.hostElement.addEventListener("afterSubmit", (e) => onAfterSubmit(e, data2.data.attributes));
      if (onBeforeSubmit) config.hostElement.addEventListener("beforeSubmit", onBeforeSubmit);
    }).catch((error2) => {
      console.error("Fetch error:", error2.message);
    });
  }, []);
  if (error === 404) return /* @__PURE__ */ React.createElement("div", null, "Did you publish your form?");
  if (!data) return /* @__PURE__ */ React.createElement("div", null, "Loading...");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormBuilderForm,
    {
      injectedData: data,
      language: config.locale,
      tintAnonymousUid: config.tintAnonymousUid,
      hostElement: config.hostElement,
      tintAnalyticsClient: analyticsClient
    }
  ));
};
